<template>
  <div>
    <div class="container">
        <h1>Privacy Policy for Nubox App</h1>

        <div style="height: 50px"></div>

        <h2>Introduction</h2>
        <p>This Privacy Policy explains how Nubox ("we", "us", or "our") collects, uses, shares, and protects user information obtained through the Nubox mobile application ("App"). By using the App, you agree to the collection and use of information in accordance with this policy.</p>

        <h2>Information Collection and Use</h2>
        <h3>A. Information You Provide</h3>
        <ul>
            <li><strong>Account Information:</strong> When you create an account, we collect your name, email address, and other relevant information.</li>
            <li><strong>Vending Machine Data:</strong> We collect data related to your vending machine operations, including sales data, inventory levels, and customer purchasing patterns.</li>
        </ul>

        <h3>B. Automatically Collected Information</h3>
        <ul>
            <li><strong>Usage Data:</strong> We collect information on how the App is accessed and used, such as the frequency and duration of usage.</li>
            <li><strong>Device Information:</strong> We collect information about the device you use to access the App, including the model, operating system, unique device identifiers, and mobile network information.</li>
        </ul>

        <h2>Use of Data</h2>
        <p>We use the collected data for various purposes:
        <ul>
            <li>To provide and maintain our App</li>
            <li>To notify you about changes to our App</li>
            <li>To allow you to participate in interactive features of our App when you choose to do so</li>
            <li>To provide customer support</li>
            <li>To gather analysis or valuable information so that we can improve our App</li>
            <li>To monitor the usage of our App</li>
            <li>To detect, prevent and address technical issues</li>
        </ul>
        </p>

        <h2>Sharing of Data</h2>
        <p>We do not sell, trade, or rent your personal identification information to others. We may share generic aggregated demographic information not linked to any personal identification information regarding visitors and users with our business partners, trusted affiliates, and advertisers for the purposes outlined above.</p>

        <h2>Data Security</h2>
        <p>We value your trust in providing us your Personal Information and are striving to use commercially acceptable means of protecting it. However, no method of transmission over the internet, or method of electronic storage is 100% secure and reliable, and we cannot guarantee its absolute security.</p>

        <h2>Changes to This Privacy Policy</h2>
        <p>We may update our Privacy Policy from time to time. We will notify you of any changes by posting the new Privacy Policy on this page. You are advised to review this Privacy Policy periodically for any changes.</p>

        <h2>Your Rights</h2>
        <p>You have the right to access, update, or delete the information we have on you. Whenever made possible, you can access, update, or request deletion of your Personal Information directly within your account settings section. If you are unable to perform these actions yourself, please contact us to assist you.</p>
    </div>

  </div>
</template>

<script>
export default {};
</script>

<style scoped>
.container {
  width: 80%;
  margin: auto;
  overflow: hidden;
  padding-top: 20px;
}

h1,
h2 {
  color: #333;
}

p,
li {
  font-size: 1.1em;
}

ul {
  margin: 10px 0;
}
</style>